import AbstractException from '../AbstractException';
import ExceptionTypeEnum from '../enums/ExceptionTypeEnum';
/**
 * Custom exception.
 */
export default class ComponentElementException extends AbstractException {
	public exceptionType = ExceptionTypeEnum.componentElement;
	public name = 'ComponentElementException';
	public elementTagName: string;

	/**
	 * Class constructor.
	 *
	 * @param element Element.
	 * @param message The error message.
	 */
	constructor(element: HTMLElement, message: string) {
		super(element.tagName + ' => ' + message);
		this.elementTagName = element.tagName;
	}
}
